import LayersPanelRedux from './LayersPanelRedux';

export default LayersPanelRedux;
